<template>
  <page-view>
    <associate-section
      :heading="$t('associateHeading')"
      :people="associateTeam"
    />
    <cooperation-section
      :heading="$t('cooperationHeading')"
      :people="cooperationTeam"
    />
    <photo-section
      :photo="teamPhoto"
    />
    <worked-section
      :heading="$t('workedHeading')"
      :people="workedTeam"
    />
  </page-view>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import AssociateSection from '@/containers/Team/AssociateSection'
import CooperationSection from '@/containers/Team/CooperationSection'
import PhotoSection from '@/containers/Team/PhotoSection'
import WorkedSection from '@/containers/Team/WorkedSection'

export default {
  components: {
    AssociateSection,
    CooperationSection,
    PhotoSection,
    WorkedSection
  },
  data () {
    return {
      teamPhoto: '/img/SAWAWA_zespol.jpg'
    }
  },
  computed: {
    ...mapGetters(['associateTeam', 'workedTeam', 'cooperationTeam'])
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchTeam')
      .then(next)
      .catch(() => {
        next({ name: 'home' })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Team/TeamContainer.vue